<template>
    <div class="dialog">
        <el-dialog :title="this.edit_id == 0 ? '创建返现活动' : '编辑返现活动'" :visible.sync="dialogVisible" width="996px" :before-close="handleClose">
            <div class="content" v-loading="loading">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" label-position="left" class="demo-ruleForm">
                    <h3 class="sub-title">基础设置</h3>
                    <el-form-item label="活动名称：" prop="name">
                        <el-input v-model="ruleForm.name" :disabled="isDetail" clearable placeholder="请输入活动名称，不超过20个字"></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间：" prop="date">
                        <el-date-picker
                            v-model="ruleForm.date"
                            style="width: 100%"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="expireTimeOption"
                            :disabled="isDetail"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="返现方式：" prop="type">
                        <el-radio-group v-model="ruleForm.type" :disabled="isDetail">
                            <el-radio label="1">返还现金</el-radio>
                            <p class="tip">返还现金为部分退款给用户</p>
                        </el-radio-group>
                    </el-form-item> -->
                    <el-form-item label="返现金额：" class="df">
                        <el-input
                            v-model="ruleForm.reward_share"
                            :disabled="Number(ruleForm.reward_share) == '' && Number(ruleForm.reward_cash) != ''"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                            style="width: 180px"
                        >
                            <template slot="append">%</template>
                        </el-input>
                        <span style="margin: 0 12px">或</span>
                        <el-input
                            v-model="ruleForm.reward_cash"
                            :disabled="Number(ruleForm.reward_cash) == '' && Number(ruleForm.reward_share) != ''"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                            style="width: 180px"
                        >
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="是否限制返现次数：" prop="rule_type" class="df">
                        <el-radio-group v-model="ruleForm.rule_type" :disabled="isDetail">
                            <el-radio :label="1">不限制</el-radio>
                            <el-radio :label="2">限制，限制次数</el-radio>
                            <el-input v-model="ruleForm.limit_order_num" :disabled="isDetail" oninput="value=value.replace(/[^\d]/g,'')" style="width: 180px" v-show="ruleForm.rule_type == 2">
                                <template slot="append">次</template></el-input
                            >
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="返现条件：">
                        <p>订单支付完成 7 天内，未申请退款</p>
                    </el-form-item>
                    <!-- <el-form-item label="活动商品：">
                        <el-button type="primary" @click="showGoods" size="small" style="margin-right: 12px">添加</el-button>
                        <span v-if="count">已添加 {{ count }} 个商品</span>
                    </el-form-item> -->
                    <el-form-item label="优惠叠加：" prop="coupon_type">
                        <el-radio-group v-model="ruleForm.coupon_type" :disabled="isDetail">
                            <el-radio :label="1">不叠加其他营销活动或优惠券</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary"
                v-if="!isDetail"
                 @click="submit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            loading: false,
            dialogVisible: false,
            ruleForm: {
                name: "",
                date: null,
                type: 1,
                rule_type: 1,
                coupon_type: 1,
                reward_share: "",
                reward_cash: "",
                limit_order_num: "",
            },
            rules: {
                name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
                date: [{ required: true, message: "请选择活动时间", trigger: "change" }],
                rule_type: [{ required: true, message: "请输入返现规则", trigger: "change" }],
            },
        };
    },
    props: {
        count: {
            type: Number,
            default: 0,
        },
        activityProductData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        edit_id: {
            type: Number,
            default: 0,
        },
        noProductEdit: {
            type: Number,
            default: 0,
        },
        isDetail: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
             /*    createActivityLink: "activity/createActivityLink",
            editLink: "activity/editLink",
            getActivityDetailLinknk: "activity/getActivityDetailLink", */
            createActivityShare: "activity/createActivityLink",
            getActivityDetail: "activity/getActivityDetailLink",
            editActivityShare: "activity/editLink",
        }),
        getDetail(id) {
            this.loading = true;
            let params = {
                token: this.getToken,
                id: id,
            };
            this.getActivityDetail(params).then(({ data }) => {
                if (data.code == 1) {
                    let { name, start_time, end_time, reward_cash, reward_share, rule_type, limit_order_num } = data.data;
                    this.ruleForm = {
                        name: name,
                        date: [start_time, end_time],
                        reward_share: Number(reward_share) == 0 ? "" : Number(reward_share),
                        reward_cash: Number(reward_cash) == 0 ? "" : Number(reward_cash),
                        rule_type: rule_type,
                        limit_order_num: limit_order_num,
                        type: 1,
                        coupon_type: 1,
                    };
                } else {
                    this.$message.error(data.msg);
                }
                this.loading = false;
            });
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // if(this.activityProductData.length == 0){
                    //     return this.$message.warning("请选择商品！")
                    // }
                    let { name, date, rule_type, reward_share, reward_cash, limit_order_num } = this.ruleForm;
                    let params = {
                        token: this.getToken,
                        name: name,
                        start_time: date ? date[0] : null,
                        end_time: date ? date[1] : null,
                        rule_type: rule_type,
                        reward_share: reward_share,
                        reward_cash: reward_cash,
                        type:3
                    };

                    if (this.ruleForm.rule_type == 2) {
                        params.limit_order_num = limit_order_num;
                    }
                    let url;
                    if (this.edit_id == 0) {
                        url = this.createActivityShare;
                    } else {
                        url = this.editActivityShare;
                        params.id = this.edit_id;
                    }
                    url(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success(`${this.edit_id == 0 ? "添加成功" : "修改成功"}！`);
                            this.handleClose();
                            this.$emit("initList");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.ruleForm = {
                name: "",
                date: null,
                type: 1,
                rule_type: 1,
                coupon_type: 1,
                reward_share: "",
                reward_cash: "",
                limit_order_num: "",
            };
            this.$emit("dataInit");
        },
        // 显示商品
        showGoods() {
            if (!this.ruleForm.date) return this.$message.warning("请先选择活动起止时间！");
            this.$emit("showGoods", this.ruleForm.date);
        },
        // 显示商品列表
        showSelDetail() {
            this.$emit("showSelDetail");
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
}
::v-deep .el-dialog__body {
    padding: 30px 80px;
}
.df {
    ::v-deep .el-form-item__content {
        display: flex;
    }
}
.el-radio {
    height: 36px;
    line-height: 36px;
}
.el-radio-group {
    position: relative;
    width: 100%;
    .el-input {
        position: absolute;
        right: 160px;
        bottom: 0;
    }
    .tip {
        position: absolute;
        right: 160px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
        color: #999;
    }
}
::v-deep .el-form-item__label {
    &::before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
    }
}
.df {
    .el-radio-group {
        display: flex;
        flex-direction: column;
    }
}
.sub-title {
    margin: 60px 0 40px;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;
    &:first-child {
        margin-top: 0;
    }
    &::before {
        content: "";
        width: 3px;
        height: 18px;
        background: #2448ff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}

::v-deep .el-range-editor.is-disabled input,
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #666;
}
</style>